module.exports = __webpack_public_path__ + "static/media/NoraJenkinsTownson.627915e0.jpeg";